'use strict';

import config from './config';

export function exception(e) {
    if (config.DEBUG_MODE) {
        console.error(e);
    }
}



// WEBPACK FOOTER //
// ./src/sink.js